export default theme => ({
    root: {},
    field: {
      margin: theme.spacing.unit * 3
    },
    portletContent: {
      minWidth: '600px'
    },
    progressWrapper: {
      padding: theme.spacing.unit * 3,
      display: 'flex',
      justifyContent: 'center'
    },
  });